import React from 'react';
import { Form, InputNumber, Select } from 'antd';
import { Box, Flex, Text } from '../../../shared/components';

const { Option } = Select;

export default function FiltroDatosMontura({
  calibreEditable, puenteEditable, dnpEditable, tipoMonturaEditable, calibre, puente, dnp, tipoMontura, onChangePuente, onChangeCalibre, onChangeDNP, onChangeTipoMontura, required,
}) {
  const style = required ? { width: '100%', borderColor: 'red' } : { width: '100%' };
  return (
    <Form layout="vertical">
      <style>
        {'.errorSelect .ant-select-selection { border-color: red;}'}
      </style>
      <Flex>
        <Box flex={1} mr="16">
          <Form.Item label="Calibre">
            <InputNumber
              disabled={calibreEditable === false}
              max={100}
              min={25}
              onChange={onChangeCalibre}
              value={calibre}
              placeholder=""
              style={style}
            />
          </Form.Item>
        </Box>
        <Box flex={1} mr="16">
          <Form.Item label="Puente">
            <InputNumber
              disabled={puenteEditable === false}
              onChange={onChangePuente}
              value={puente}
              placeholder=""
              style={style}
            />
          </Form.Item>
        </Box>
        <Box flex={1} mr="16">
          <Form.Item label="Dis. Naso pupilar">
            <InputNumber
              disabled={dnpEditable === false}
              onChange={onChangeDNP}
              value={dnp}
              placeholder=""
              style={style}
            />
          </Form.Item>
        </Box>
        <Box flex={3} className={required ? "errorSelect": ''}>
          <Form.Item label="Tipo de montura">
            <Select
              disabled={tipoMonturaEditable === false}
              onChange={onChangeTipoMontura}
              value={tipoMontura}
              allowClear
              style={{ ...style, display: 'block' }}
              placeholder="Seleccione tipo de montura"
              showAction={['focus', 'click']}
            >
              <Option value="1">PASTA</Option>
              <Option value="2">METAL</Option>
              <Option value="3">RANURADA</Option>
            </Select>
          </Form.Item>
        </Box>
      </Flex>
    </Form>
  );
}
